<script setup lang="ts">
import LeIconButton from "@dsk/components/IconButton/LeIconButton.vue";
import LeCross from "@dsk/icons/LeCross.vue";
import { computed } from "vue";
import { useI18n } from "vue-i18n";

const props = defineProps<{
  type?: "neutral" | "attention";
  withCloseButton?: boolean;
}>();

const emit = defineEmits<{
  (event: "hide"): void;
}>();

const { t } = useI18n();

const typeClass = computed<string>(() => `le-banner--${props.type}`);
const closeButtonColor = computed<"primary" | "accent">(() => (props.type === "neutral" ? "primary" : "accent"));
</script>

<template>
  <div class="le-banner" :class="typeClass">
    <div class="container">
      <div class="row">
        <div
          class="col-xs-12 le-banner__content"
          :class="{ 'le-banner__content--with-close-button': props.withCloseButton }"
        >
          <p class="le-banner__text">
            <slot />
          </p>

          <div v-if="withCloseButton" class="le-banner__icon">
            <LeIconButton :aria-label="t('hide')" :color="closeButtonColor" @click="emit('hide')">
              <LeCross role="presentation" />
            </LeIconButton>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="less" scoped>
@import "@dsk/styles/all.less";

.le-banner {
  width: 100%;
  min-height: 50px;
  text-align: center;

  &--neutral {
    background-color: @colors[@neutrals][100];
  }

  &--attention {
    background-color: @colors[@accent][200];
  }

  &__content {
    display: grid;
    grid-template-columns: auto;

    &--with-close-button {
      grid-template-columns: auto 50px;
    }
  }

  &__text {
    margin-bottom: 0;
    padding-top: 16px;
    padding-bottom: 16px;
    .body-text("s");
    color: @colors[@primary][900];
  }

  &__icon {
    padding-top: 12px;
    padding-bottom: 12px;
    text-align: right;
  }
}
</style>

<i18n lang="json">
{
  "da": {
    "hide": "Skjul besked"
  },
  "de": {
    "hide": "Nachricht ausblenden"
  },
  "en": {
    "hide": "Hide message"
  }
}
</i18n>
